<template>
  <Container>
    <Name>{{ data.serie }}</Name>
    <Value>{{ orderOfMagnitude(data.value) }}</Value>
  </Container>
</template>

<script>
import { Container, Name, Value } from './serieTooltip.styles';
import { orderOfMagnitude } from '../../../../utils/formatNumbers';

export default {
  components: { Container, Name, Value },
  props: {
    data: { type: Object, default: () => ({ serie: '', value: 0 }) },
  },
  data() {
    return {
      orderOfMagnitude,
    };
  },
};
</script>
